define('modules/editor/views/sidebar',['require','exports','module','base/layout','../views/edit_element_popup','../models/editorstate','common/models/appstate','./elements_tree','./element_popup_info','lib/util','./correodirect_popup','common/views/confirmation_popup','ldsh!../templates/sidebar_amp','ldsh!../templates/sidebar'],function (require, exports, module) {
  'use strict';

  var Layout = require('base/layout'),
    EditElementPopup = require('../views/edit_element_popup'),
    EditorState = require('../models/editorstate'),
    AppState = require('common/models/appstate'),
    ElementsTreeView = require('./elements_tree'),
    ElementsPopupInfo = require('./element_popup_info'),
    util = require('lib/util'),
    CorreoDirectModalView = require('./correodirect_popup'),
    ConfirmationPopup = require('common/views/confirmation_popup');

  var Controller = {
    onDragstart: function (type, e) {
      EditorState.deselect();
      e.originalEvent.dataTransfer.setData('text', 'toolbar element');
      e.originalEvent.dataTransfer.effectAllowed = 'copy';
      this.data.state.setDragPayload(type, 'copy');
    },

    onDragend: function () {
      this.data.state.clearDragPayload();
    },

    addNewSection: function (e) {
      e.preventDefault();
      this.data.addNewSection();
    },

    deleteActiveItem: function () {
      this.data.deleteSelectedItem();
    },

    //styles
    editStyles: function (e) {
      e.preventDefault();
      this.vent.trigger('edit:styles');
    },

    editScripts: function (e) {
      e.preventDefault();
      var $currentTarget = e.currentTarget;

      if (util.isFieldDisabled($currentTarget)) {
        return false;
      }

      util.disableField($currentTarget);
      this.vent.trigger('edit:scripts');
    },

    //seo
    editSEO: function (e) {
      e.preventDefault();
      this.vent.trigger('edit:seo');
    },

    //page properties
    editPageProperties: function (e) {
      e.preventDefault();
      new EditElementPopup({
        page: this.data.getVariant(),
      });
    },

    //correo direct frontend integration
    editCorreoDirect: function (e) {
      e.preventDefault();
      var variant = EditorState.get('variant');
      new CorreoDirectModalView({
        model: variant.getCorreoDirect(),
        collection: variant.getFormFields(),
        onSave: function (popUp) {
          var mainForm = variant.getContent().sections.getForm();
          if (!popUp.model.get('active') || (mainForm && mainForm.hasLegal())) {
            popUp.collection.each(function (form) {
              var index = form.get('step'),
                step = variant.content.at(index),
                stepForm = step.hasElement('element:form'),
                integration = stepForm.getPropertyGroup('form:integration:correodirect'),
                correodirectData = _.omit(popUp.model.toJSON(), 'fields');
              stepForm.fields = form.fields.toJSON();
              integration.set(correodirectData, { silent: true });
              integration.trigger('change', integration);
            });
            // variant.setCorreoDirect(popUp.model);
            popUp.hide();
          } else {
            popUp.model.set('active', false);
            popUp.showErrors([{ attribute: 'active' }]);
          }
        },
      });
    },

    convertStepInPopup: function (e) {
      e.preventDefault();

      var self = this,
        confirmationParams = {
          title: $.i18n.t('editor.popup.convertStepIntoPopupTitle'),
          message: $.i18n.t('editor.popup.convertStepIntoPopupDetails'),
          okButton: 'editor.popup.convertButton',
        };

      ConfirmationPopup.show(confirmationParams).then(function () {
        self.data.set({ role: 'popup' });
        EditorState.setVariantChanged(true, true);
        self.vent.trigger('variant:reload');

        return true;
      });
    },

    convertPopupInStep: function (e) {
      e.preventDefault();

      var self = this,
        stepContainsForm = !!this.data.hasElement('element:form'),
        confirmationParams = {
          title: $.i18n.t('editor.popup.convertPopupIntoStepTitle'),
          message: $.i18n.t('editor.popup.convertPopupIntoStepDetails'),
          okButton: 'common.okButton',
        };

      if (!stepContainsForm) {
        confirmationParams.message +=
          '<p class="mt30 pb30 text--errorNormal">' +
          $.i18n.t('editor.popup.convertPopupIntoStepWithoutForm') +
          '</p>';
      }

      ConfirmationPopup.show(confirmationParams).then(function () {
        self.data.set({ role: 'step' });
        EditorState.setVariantChanged(true, true);
        self.vent.trigger('variant:reload');

        return true;
      });
    },

    //move sections
    moveSectionUp: function (e) {
      e.preventDefault();
      this.data.moveSectionUp();
    },

    moveSectionDown: function (e) {
      e.preventDefault();
      this.data.moveSectionDown();
    },

    moveUpElement: function (e) {
      e.preventDefault();
      this.data.moveUpElement();
    },

    moveDownElement: function (e) {
      e.preventDefault();
      this.data.moveDownElement();
    },
  };

  module.exports = Layout.extend({
    template: function () {
      return this._getSidebarTemplate();
    },
    events: {
      'dragstart .js-section-button': util.bbinvoker('onDragstart', 'section'),
      'dragstart .js-text-element': util.bbinvoker('onDragstart', 'element:text'),
      'dragstart .js-button-element': util.bbinvoker('onDragstart', 'element:button'),
      'dragstart .js-form-element': util.bbinvoker('onDragstart', 'element:form'),
      'dragstart .js-video-element': util.bbinvoker('onDragstart', 'element:video'),
      'dragstart .js-image-element': util.bbinvoker('onDragstart', 'element:image'),
      'dragstart .js-area-element': util.bbinvoker('onDragstart', 'element:area'),
      'dragstart .js-html-element': util.bbinvoker('onDragstart', 'element:html'),
      'dragstart .js-social-element': util.bbinvoker('onDragstart', 'element:social'),
      'dragstart .js-popup-element': util.bbinvoker('onDragstart', 'element:popup'),

      //sections
      'click .js-section-button': 'addNewSection',
      'click .js-delete': 'deleteActiveItem',
      'dragend .btn': 'onDragend',

      //styles
      'click .js-css-button': 'editStyles',
      'click .js-script-button': 'editScripts',

      //seo
      'click .js-seo-button': 'editSEO',

      //page properties
      'click .js-page-properties': 'editPageProperties',
      'click .js-correo-direct': 'editCorreoDirect',

      //popup
      'click .js-page-step-to-popup': 'convertStepInPopup',
      'click .js-page-popup-to-step': 'convertPopupInStep',
    },

    regions: {
      elementsTree: '.ed-layers-tree',
      elementsPopupInfo: '.ed-layers-popupInfo',
    },

    initialize: function (options) {
      this.data = options.data;
      this.vent = options.vent;
      this._initListeners();
      this.regions.elementsTree.show(new ElementsTreeView(this.data));

      this.initPopupInfoIfNeeded();
    },

    _initListeners: function () {
      this.listenTo(this.data, 'form:added', this._toggleFormButton);
      this.listenTo(this.data, 'form:removed', this._toggleFormButton);
      this.listenTo(this.data, 'section:added section:removed', this._toggleButtons);
      this.listenTo(this.data, 'change', this._toggleButtons);
      this.listenTo(
        AppState._companyInfo,
        'change:correo_direct_is_available',
        this._toggleCorreoDirectButton
      );
    },

    initPopupInfoIfNeeded: function () {
      if (EditorState.isCurrentStepPopup()) {
        this.regions.elementsPopupInfo.show(new ElementsPopupInfo());
      }
    },

    _getSidebarTemplate: function () {
      var isAMP = EditorState.getAMPState();
      $('.js-aside').toggleClass('isAMP', isAMP);

      if (isAMP) {
        return require('ldsh!../templates/sidebar_amp');
      }

      return require('ldsh!../templates/sidebar');
    },

    setupToolbar: function () {
      this._invalidateElementsInToolbar();
      this._toggleButtons();
    },

    _isVariantAMP: function () {
      var variant = EditorState.get('variant');
      return util.isVariantAMP(variant);
    },

    _invalidateElementsInToolbar: function () {
      _.each(this._getInvalidElements(), this._invalidateElement, this);
    },

    _getInvalidElements: function () {
      return _.result(this.data, 'invalidElements') || [];
    },

    _invalidateElement: function (elementKey) {
      var selector = '.js-' + elementKey + '-element';
      this.$(selector).addClass('is-disabled');
    },

    _toggleFormButton: function () {
      var disabled =
        !!this.data.hasElement('element:form') ||
        this._isConfirmationStep() ||
        !this._thereAreSections();
      this.$('.js-form-element').toggleClass('is-disabled', disabled).attr('draggable', !disabled);
    },

    _toggleButtons: function () {
      //disable all element buttons if there are no sections
      this.$('b[class*=element], .js-section-up, .js-section-down, .js-duplicate').toggleClass(
        'is-disabled',
        !this._thereAreSections()
      );
      this._toggleFormButton();
    },

    _toggleCorreoDirectButton: function (active) {
      this.$('.js-page-properties').toggleClass('ed-c-half-btn', active);
      this.$('.js-page-properties').toggleClass('ed-c-full-btn', !active);
      this.$('.js-correo-direct').toggleClass('hidden', !active);
    },

    _toggleComponentsInPopupMode: function () {
      if (this._isPopupStep()) {
        this.$('.js-seo-button').addClass('ed-c-btn-disabled');
        this.$('.js-page-properties').addClass('ed-c-half-btn');
        this.$('.js-page-popup-to-step').removeClass('hidden');

        if (!this._isVariantAMP()) {
          this.$('.js-css-button, .js-script-button').addClass('ed-c-half-btn');
        }
      }
    },

    _toggleComponentsInStepMode: function () {
      if (this._isNormalStep()) {
        this.$('.js-page-properties').addClass('ed-c-half-btn');
        this.$('.js-page-step-to-popup').removeClass('hidden');
      }
    },

    _isConfirmationStep: function () {
      return this.data.get('role') === 'confirmation';
    },

    _isPopupStep: function () {
      return this.data.get('role') === 'popup';
    },

    _isNormalStep: function () {
      return this.data.get('role') === 'step';
    },

    _thereAreSections: function () {
      return this.data.getSectionCount() > 0;
    },

    _checkIfCorreoDirectIsAvailable: function () {
      return !this._isVariantAMP() && AppState.isCorreoDirectAvailable();
    },

    onRender: function () {
      this.$el.i18n();
      this.setupToolbar();
      this._toggleFormButton();
      this._toggleCorreoDirectButton(this._checkIfCorreoDirectIsAvailable());
      this._toggleComponentsInPopupMode();
      this._toggleComponentsInStepMode();
    },
  });

  util.mixin(module.exports, Controller);
});

